import React, { Component } from "react";
import PropTypes from "prop-types";

class MediaItem extends Component {
	constructor(props) {
		super(props);

	}
	render() {
		var {file, url, deleteFile, selectFile} = this.props;
		return(
			<div style={{
				width:"250px",
				height:"380px",
				border:"1px black solid",
				margin:"10px",
				padding:"10px",
				float:"left",
				position:"relative"
			}}>
				<img src={url} style={{
					width:"230px",
					height: "230px",
					objectFit:"contain",
					backgroundColor: "#ddd"
				}}/><br/>
				<span style={{
					width:"220px",
					maxHeight:"42px",
					overflow:"hidden",
					display: "-webkit-box",
					"-webkit-line-clamp": "2",
					"-webkit-box-orient": "vertical"
					
				}}
				>{file.fileName}</span><br/>
				<button 
					className="btn btn-primary wide" 
					onClick={() => selectFile(url)}
					style={{
						bottom:"50px",
						position:"absolute",
						width:"91%"

					}}>Select</button>
				<button 
					className="btn btn-danger-outline wide" 
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						e.nativeEvent.stopImmediatePropagation();
						if (window.confirm("Are you sure you want to remove this file from the file manager?")){
							deleteFile(file);
						}
						else return null;
					}}
					style={{
						bottom:"10px",
						position:"absolute",
						width:"91%",
					}}>Remove</button>
			</div>
		);
	}
}

MediaItem.propTypes = {
	file: PropTypes.object,
	url: PropTypes.string,
	deleteFile: PropTypes.func,
	selectFile: PropTypes.func,
	isFolder: PropTypes.bool,
};

export default MediaItem;